export const GET_V3_CONTRIBUTION_AMOUNT_QUERY_KEY = 'contributionAmountGet';
